import getURLParameter from '../common/getURLParameter.js'
import drawCommonModel from './drawCommonModel.js'
import xss from 'xss'
// XSS过滤
var myXss = new xss.FilterXSS({
    whiteList:          [],        // 白名单为空，表示过滤所有标签
    stripIgnoreTag:     true,      // 过滤所有非白名单标签的HTML
    stripIgnoreTagBody: ['script'] // script标签较特殊，需要过滤标签中间的内容
});
// var urlParams = getURLParameter()
export default {
    banner_1: drawBanner_1_Model, 		   /*1张纯图片banner      绘制 模块*/
    banner_2: drawBanner_2_Model, 		   /*2张纯图片banner      绘制 模块*/
    banner_3: drawBanner_3_Model, 		   /*3张纯图片banner      绘制 模块*/
    banner_12_white: drawBanner_12w_Model, /*左1右2白底图文banner 绘制 模块*/
    banner_12_pic: drawBanner_12p_Model,    /*左1右2纯图片banner   绘制 模块*/
    banner_2_title:drawBanner_2_title_Model,		/*2列_纯图_banner_含标题 banner 模块*/
    banner_3_word:drawBanner_3w_Model,		/*3列_图文 banner 模块*/
    banner_4_word:drawBanner_4w_Model,		/*4列_图文 banner 模块*/
    drawBanner4PicScene,
	drawBanner2PicScene,
	dynamicChunzhan
}

function dynamicChunzhan(data,moduleIndex) {
	const info = data.infoList[0]
	return `<section class="banner-dynamic-chunzhan visiblereport-luna" data-exposurelog='${JSON.stringify({module_id: 23, extralParam: {cz_strategy: info.cz_strategy, cz_strategy_cont: info.cz_strategy_cont}})}'>
		<a class="clickreport clickreport-luna-chunzhan" href="${info.linkUrl}" data-exposurelog='${JSON.stringify({cz_strategy: info.cz_strategy, cz_strategy_cont: info.cz_strategy_cont})}' data-clickLog="${`${moduleIndex}_0_`}">
			<div class="title">${info.firsttxt}</div>
			<div class="subTitle">${info.secondtxt}</div>
			<img class="bg" src="${info.imgUrl}" />
		</a>
	</section>`
}

function drawBannerPicScene({data, statisticsOpts: {class: statisticsClass, setParams: setStatisticsParams}},moduleIndex) {
    return `<div class="banner-pic-scene-wrap">
        ${drawCommonModel.drawTitleModel(data,moduleIndex)}
        <ul class="content">
            ${data.infoList.map(({linkUrl = '', tag = '', imgUrl = '', firsttxt = ''} ={},index) => `<li class="content-item__wrap clickreport ${statisticsClass}" ${typeof setStatisticsParams === 'function' ? `data-exposurelog='${JSON.stringify(setStatisticsParams({linkUrl}))}'` : ''} data-clickLog="${`${moduleIndex}_${index}_`}">
                <a class="content-item__link" href="${linkUrl.replace(/^(http|https):/, '')}&tag=${tag}" data-tag="${tag}" style="background-image: url(${imgUrl})">
                    <h2 class="content-item__title"><span class="content-item__txt">${firsttxt}</span></h2>
                </a>
            </li>`).join('')}
        </ul>
    </div>`
}

function drawBanner4PicScene(data,moduleIndex) {
    return `<section class="banner-4-pic-scene-wrap visiblereport-luna" data-exposurelog='${JSON.stringify({module_id: 21, extralParam: {name: data.infoList.map(({firsttxt}) => firsttxt).join(',')}})}'>
        ${drawBannerPicScene({
            data,
            statisticsOpts: {
                class: 'clickreport-luna-rank',
                setParams({linkUrl}) {
                    return {
                        style: myXss.process(getURLParameter(linkUrl)['sceneType'])
                    } 
                }
            }
        },moduleIndex)}
    </section>`
}

function drawBanner2PicScene(data,moduleIndex) {
    return `<section class="banner-2-pic-scene-wrap visiblereport-luna" data-exposurelog='${JSON.stringify({module_id: 20, extralParam: {name: data.infoList.map(({firsttxt}) => firsttxt).join(',')}})}'>
        ${drawBannerPicScene({
            data,
            statisticsOpts: {
                class: 'clickreport-luna-quiz',
                setParams() {
                    return {
                        qapos: 0
                    } 
                }
            }
        },moduleIndex)}
    </section>`
}

/**
 * 1张纯图片banner 绘制 模块
 * 
 * @param  {Object} data 
 * 详见pageMock.js文件中"modelType":"banner_1"的infoList数组
 * 
 * @return {String}      
 * 拼接后的dom
 */
function drawBanner_1_Model(data,cName,moduleIndex) {
    cName = cName ? cName : 'banner-model banner-model-1'
    return `<section class="${cName}">
				<div class="model-box">
					<ul class="swiper-wrapper">
					${data.infoList.map((item,index) => `
						<li class="swiper-slide">
							<a class="banner-box clickreport clickreport-luna-banner" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-clickLog="${`${moduleIndex}_${index}_`}">
								<img src="${item.imgUrl}"/>
							</a>
						</li>
					`).join('')}
					<a href="#"></a>
					</ul>
					<div class="swiper-pagination"></div>
				</div>
			</section>`
}

/**
 * 2张纯图片banner 绘制 模块
 * 
 * @param  {Object} data 
 * 详见pageMock.js文件中"modelType":"banner_2"的infoList数组
 * 
 * @return {String}      
 * 拼接后的dom
 */
function drawBanner_2_Model(data,cName,moduleIndex) {
    cName = cName ? cName : 'banner-model banner-model-2'
    return `<section class="${cName}">
			${data.infoList.map((item,index) =>`
				<a class="banner-box clickreport clickreport-luna-banner" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-clickLog="${`${moduleIndex}_${index}_`}">
					<img src="${item.imgUrl}" />
				</a>
			`).join('')}
		</section>`
}

/**
 * 3张纯图片banner 绘制 模块
 * 
 * @param  {Object} data 
 * 详见pageMock.js文件中"modelType":"banner_3"的infoList数组
 * 
 * @return {String}      
 * 拼接后的dom
 */
function drawBanner_3_Model(data,cName,moduleIndex) {
    cName = cName ? cName : 'banner-model'
    return `<section class="${cName} banner-model-3">
			${data.infoList.map((item,index) =>`
				<a class="banner-box clickreport clickreport-luna-banner" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-clickLog="${`${moduleIndex}_${index}_`}">
					<img src="${item.imgUrl}" />
				</a>
			`).join('')}
		</section>`
}

/**
 * 左1右2白底图文banner 绘制 模块
 * 
 * @param  {Object} data 
 * 详见pageMock.js文件中"modelType":"banner_12_white"的infoList数组
 * 
 * @return {String}      
 * 拼接后的dom
 */
function drawBanner_12w_Model(data,cName,moduleIndex) {
    cName = cName ? cName : 'banner-model'
    return `<section class="${cName} banner_model-12w">
			${data.infoList.map((item,index) =>`
				<a class="banner-box clickreport clickreport-luna-banner" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-clickLog="${`${moduleIndex}_${index}_`}">
					<h1 class="title${item.hot ? ' icon-HOT' : ''}">${item.firsttxt}</h1>
					<h2 class="subhead">${item.secondtxt}</h2>
					<img src="${item.imgUrl}" />
				</a>
			`).join('')}
		</section>`
}

/**
 * 左1右2纯图片banner 绘制 模块
 * 
 * @param  {Object} data 
 * 详见pageMock.js文件中"modelType":"banner_12_pic"的infoList数组
 * 
 * @return {String}      
 * 拼接后的dom
 */
function drawBanner_12p_Model(data,cName,moduleIndex) {
    cName = cName ? cName : 'banner-model'
    return `<section class="${cName} banner-model-12p">
			${data.infoList.map((item,index) =>`
				<a class="banner-box clickreport clickreport-luna-banner" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-clickLog="${`${moduleIndex}_${index}_`}">
					<img src="${item.imgUrl}" />
				</a>
			`).join('')}
		</section>`
}


/**
 * 2列_纯图_banner_含标题 绘制 模块
 *
 * @param  {Object} data
 * 详见pageMock.js文件中"modelType":"banner_2"的infoList数组
 *
 * @return {String}
 * 拼接后的dom
 */
function drawBanner_2_title_Model(data,cName,moduleIndex){
    cName = cName ? cName : 'banner-model'
    return `<section class="${cName} banner-model-2-title">
				${drawCommonModel.drawTitleModel(data,moduleIndex)}
				<div class="model-box">
					${data.infoList.map((item,index) =>`
						<a class="banner-box clickreport clickreport-luna-banner" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-clickLog="${`${moduleIndex}_${index}_`}">
							<img src="${item.imgUrl}" />
						</a>
					`).join('')}
				</div>
			</section>`
}

/**
 * 3列_图文 绘制 模块
 *
 * @param  {Object} data
 * 详见pageMock.js文件中"modelType":"banner_2"的infoList数组
 *
 * @return {String}
 * 拼接后的dom
 */
function drawBanner_3w_Model(data,cName,moduleIndex){
    cName = cName ? cName : 'banner-model'
    return `<section class="${cName} banner-model-3w">
				${drawCommonModel.drawTitleModel(data,moduleIndex)}
				<div class="model-box">
					${data.infoList.map((item,index) =>`
						<a class="banner-box clickreport clickreport-luna-banner" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-clickLog="${`${moduleIndex}_${index}_${item.txt}`}">
							<div class="imgBox"><img src="${item.imgUrl}" /></div>
							${item.imgLabel.trim() ? `<span class="icon-imgLabel">${item.imgLabel}</span>` : ''}
							<p ${getTxtClass(item)}>
								${item.txt}
							</p>
						</a>
					`).join('')}
				</div>
			</section>`
}
/**
 * 4列_图文 绘制 模块
 *
 * @param  {Object} data
 * 详见pageMock.js文件中"modelType":"banner_2"的infoList数组
 *
 * @return {String}
 * 拼接后的dom
 */
function drawBanner_4w_Model(data,cName,moduleIndex){
    cName = cName ? cName : 'banner-model'
    return `<section class="${cName} banner-model-4w">
				${drawCommonModel.drawTitleModel(data,moduleIndex)}
				<div class="model-box">
					${data.infoList.map((item,index) =>`
						<a class="banner-box clickreport clickreport-luna-banner" href="${item.linkUrl}&tag=${item.tag}" data-tag="${item.tag}" data-clickLog="${`${moduleIndex}_${index}_${item.txt}`}">
							<div class="imgBox"><img src="${item.imgUrl}" /></div>
							${item.imgLabel.trim() ? `<span class="icon-imgLabel">${item.imgLabel}</span>` : ''}
							<p ${getTxtClass(item)}>
								${item.txt}
							</p>
						</a>
					`).join('')}
				</div>
			</section>`
}

/**
 * 判断文字链是否为 热门 最新 标红, 返回类名
 *
 * @param  {Object} item
 * 详见pageMock.js文件中"modelType":"link_3"的infoList数组中的对象
 *
 * @return {String}
 * 类名
 */
function getTxtClass(item) {
    var classStr = ''
    if(item.hot){
        classStr += 'class="icon-H'
    }else if(item.new){
        classStr += 'class="icon-N'
    }
    if(item.red){
        classStr += (classStr === '' ? 'class="colorOrange' : ' colorOrange')
    }
    classStr += '"'
    return classStr
}